export default __webpack_public_path__ + "static/media/Mobile_Background.22fe9603.png";